export const LogoMark = ({ size = 34 }) => (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
        <rect width="64" height="64" rx="15" fill="#164B3B" />
        <path
            d="M13 33h9l5-15 9 30 5-15h10"
            stroke="#BE9956"
            strokeWidth="4.2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const Logo = ({ dark = false }) => (
    <span className="inline-flex items-center gap-3" data-testid="brand-logo">
        <LogoMark />
        <span
            className={`font-heading font-extrabold tracking-tight text-xl ${
                dark ? "text-ivory" : "text-forest"
            }`}
        >
            BODY<span className="text-gold-dark">COACHIA</span>
        </span>
    </span>
);
